<template>
  <div>
    <a-card class="customer-filter">
      <service-filter-form ref="filterFormRef" v-model="filterForm" type="project" :service-strategys="serviceStrategys" @change="onFilter" @reset="onReset" />
    </a-card>
    <a-card title="服务列表" size="small" class="filter-data">
      <span slot="extra">
        <a-space>
          <a-button v-has="{ code: 'project:service:create:apply', project: projectId }" type="primary" icon="plus" @click="onCreateApply">申请创建新服务</a-button>
        </a-space>
      </span>
      <service-data-list ref="serviceDataListRef" :service-strategys="serviceStrategys" type="project" :project-id="projectId" />
    </a-card>
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { serviceSpecialTests } from '@/utils/dictionary';

import ServiceDataList from '@/pages/system/components/ServiceDataList';
import ServiceFilterForm from '@/pages/system/components/ServiceFilterForm';

export default {
  components: { ServiceDataList, ServiceFilterForm },
  data() {
    return {
      serviceSpecialTests,
      filterForm: {},
      loading: false,
      tableData: [],
      serviceStrategys: {},
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  mounted() {
    this.getTagData();
    this.onFilter();
  },
  methods: {
    /**
     * 筛选数据事件
     */
    onFilter() {
      this.$nextTick(() => {
        this.$refs.serviceDataListRef.setFilter({ ...this.filterForm, project_id: this.projectId });
      });
    },

    /**
     * 获取发布策略
     */
    getTagData() {
      tagList({ group_code: 'release_strategy' }).then(res => {
        const tags = {};
        res.data.items.forEach(item => {
          tags[item.name] = item;
        });
        this.serviceStrategys = tags;
      });
    },

    // 点击重置
    onReset() {
      this.filterForm = {};
      this.onFilter();
    },

    onCreateApply() {
      this.$router.push({
        name: 'page:project:service:create:apply'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.customer-filter {
  margin-bottom: 16px;
}
</style>
